const productEvents = {
  FETCH_PRODUCT_DATA_PROGRESS: 'product/fetch_data_progress',
  FETCH_PRODUCT_DATA_SUCCESS: 'product/fetch_data_success',
  FETCH_PRODUCT_DATA_NOT_FOUND: 'product/fetch_data_not_found',
  FETCH_PRODUCT_DATA_FAILED: 'product/fetch_data_failed',
  CHANGE_PRODUCT_VARIANT: 'product/change_variant',
  PRODUCT_LIKE_REVIEW: 'product/like_review',
  FETCH_OFFERS_PROGRESS: 'product/fetch_product_offers_progress',
  FETCH_COUPONS_AND_OFFERS_SUCCESS:
    'product/fetch_product_coupons_and_offers_success',
  FETCH_OFFERS_FAILED: 'product/fetch_product_offers_failed',
  PRODUCT_ADDITIONAL_OFFER: 'product/additionalOffers',
  BANNERS_SUCCESS: 'product/banners_success',
  CATEGORY_WIDGET_SUCCESS: 'product/category_widget_success',
  PRODUCT_UNMOUNT: 'product/unmount',
  FETCH_HYBIRD_PRODUCT_DATA_SUCCESS: 'product/fetch_hybrid_data_success',
  SET_BREADCRUMB: 'product/set_breacrumbs',
  UPDATE_BESTPRICE_COUPON: 'UPDATE_BESTPRICE_COUPON',
  UPDATE_PERSONALIZED_BESTPRICE_COUPON: 'UPDATE_PERSONALIZED_BESTPRICE_COUPON',
};
export default productEvents;
